<div class="divider w-100 th-bg-border-line-background {{this.getClass()}}"></div>
